<template>
  <div
    v-if="redirectUrl"
    class="text-body-2 text-secondary--text text-center"
    data-qa="redirect_timer_medtochka"
  >
    <slot>
      {{ $t('МедТочка откроется через', options) }} <span id="timer" /> {{ $t('секунд', options) }}
    </slot>
  </div>
</template>

<script>
import { APPOINTMENT_YANDEX_GOALS } from 'www/yandexGoals'
import { setLocation } from 'www/utils'
import ExpireTime from 'www/modules/ExpireTime'
import YandexGoals from 'www/modules/YandexGoals'
import { PAGE_TYPES } from 'www/vue_components/common/MedtochkaRedirect/constants'

export default {
  name: 'MedtochkaRedirect',
  props: {
    redirectUrl: {
      type: String,
      default: '',
    },
    pageType: {
      type: String,
      default: PAGE_TYPES.appointment,
    },
  },
  data: vm => ({
    instanceYaGoals: new YandexGoals(),
    options: { ns: vm.$i18next.language },
  }),
  mounted() {
    if (!this.redirectUrl) {
      return
    }

    new ExpireTime({
      timeFormat: 's',
      offsetMinutes: 0,
      offsetSeconds: 15,
      startDate: new Date().toISOString(),
      mountSelector: '#timer',
      afterCountdown: () => {
        if (this.pageType === PAGE_TYPES.appointment) {
          this.instanceYaGoals.send({ name: APPOINTMENT_YANDEX_GOALS.timerRedirectToMedtochka })
        }

        setLocation(this.redirectUrl)
      },
    })
  },
}
</script>
